/*
  中文
*/
export default {
  headerBar: {
    allProducts: '所有产品',
    newIn: '新品',
    bestSellers: '热销',
    specialOffer: '折扣促销',
    explore: '新潮',
    fashionTrends: '时尚潮流',
    whyUs: '关于我们',
    helpCenter: '帮助中心',
    company: '公司',
    dropshipping: '厂商直销',
    aboutUs: '公司简介',
    blog: '博客',
    login: '登录',
    register: '免费注册',
    searchingFor: '搜索',
    wishList: '愿望清单',
    listing: '刊登列表',
    allOrder: '全部订单',
    accountSetting: '账户设置',
    logOut: '退出登录',
    home: '首页',
    startSelling: '开始销售',
    wholesale: '批发'
  },
  indexPage: {
    hello: '你好',
    allCategory: '所有类别',
    apparelWholesale: '服装批发',
    smartDropshiping: '智能拖放',
    smallMOQCustomization: '小型MOQ定制',
    fastWorldwideShipping: '快速全球发货',
    estimateShippingCost: '运输成本计算',
    flashSale: '秒杀商品',
    customization: '定制产品',
    customizationText1: '有500多名供应商和100多名设计师，',
    customizationText2: '独家产品只能为您定制。',
    ins: 'Ins潮品',
    insText1: '时尚潮流上的最新款式，以获得inspo的服装。',
    insText2: '为您的销售提供相同的设计。',
    youMayLike: '猜你喜欢',
    viewMore: '更多'
  }
}
